import axios from 'axios';
import type {
  ByOperatorResponse,
  CategorySummary,
  CategoryTimelineResponse,
  DomainsPage,
  Params,
} from './types';

const base = (operatorId: string) => `/v2/op/dns-records/${operatorId}`;

// Only sends the filters that are set; the backend treats a missing cpeId/devId as "whole operator".
const query = (p: object) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== undefined && v !== ''));

export const fetchSummary = async (operatorId: string, p: Params): Promise<CategorySummary> =>
  (await axios.get(`${base(operatorId)}/category-summary`, { params: query(p) })).data;

export const fetchTimeline = async (
  operatorId: string,
  p: Params & { categoryIds?: string[] }
): Promise<CategoryTimelineResponse> =>
  (
    await axios.get(`${base(operatorId)}/category-timeline`, {
      params: query({ ...p, categoryIds: p.categoryIds?.join(',') }),
    })
  ).data;

export const fetchDomains = async (
  operatorId: string,
  categoryId: string,
  p: Params & { page: number; size: number; q?: string }
): Promise<DomainsPage> =>
  (
    await axios.get(`${base(operatorId)}/category-domains/${encodeURIComponent(categoryId)}`, {
      params: query(p),
    })
  ).data;

export const fetchByOperator = async (operatorId: string, p: Params): Promise<ByOperatorResponse> =>
  (await axios.get(`${base(operatorId)}/category-by-operator`, { params: query({ l: p.l }) })).data;
